import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import 'leaflet/dist/leaflet.css';
import './styles/index.css';
import App from './App';
import { initPerformanceMetrics } from './utils/performanceMetrics';

// Força execução do guard do Firebase (mostra aviso no console se faltar apiKey)
import './services/firebase';

// Collect Core Web Vitals (LCP, INP, CLS, FCP, TTFB)
initPerformanceMetrics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);